/* 
【dAgora】作り手コレクション＆作家コレクション一覧ページ用JS
 1.プロフィール成形用JS
ver管理
1.0 : 25/10/10 dAgora
*/

/* 1.作家プロフィール成形用JS */
document.addEventListener("DOMContentLoaded", function () {

  // PCは details を open にして、UAの折りたたみ挙動を避ける（安定化）
  const isDesktop = window.matchMedia('(min-width: 990px)').matches;
  if (isDesktop) {
    document.querySelectorAll('details.dag-creator-career-toggle').forEach(d => d.open = true);
  }

  function richTextToLines(container) {
    // リッチテキストHTMLを改行付きプレーンテキストに変換
    let html = container.innerHTML || "";

    // br / p を改行に寄せる
    html = html
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<\/div>/gi, "\n")
      .replace(/<\/li>/gi, "\n");

    // 残りのタグを除去
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    let text = tmp.textContent || "";

    // 改行コードを正規化
    text = text
      .replace(/\u2028|\u2029/g, "\n")
      .replace(/\r\n|\r/g, "\n");

    // 行配列へ
    return text
      .split("\n")
      .map(l => l.trim())
      .filter(l => l.length > 0);
  }

  document.querySelectorAll('[data-career="true"]').forEach(container => {
    const lines = richTextToLines(container);

    const html = lines.map(line => {
      // 全角パイプも半角に寄せる
      const normalized = line.replace(/｜/g, "|");

      // 「年｜内容」または「年|内容」
      if (normalized.includes("|")) {
        const [yearRaw, contentRaw] = normalized.split("|");
        const year = (yearRaw || "").trim();
        const content = (contentRaw || "").trim();

        const yearHtml = year
          ? `<div class="career-year">${year}</div>`
          : `<div class="year-null"> </div>`;

        return `<div class="career-paragraph">${yearHtml}<div class="career-detail">${content}</div></div>`;
      }

      // パイプなし行
      return `<div class="career-paragraph"><div class="career-detail">${line}</div></div>`;
    }).join("");

    container.innerHTML = html;
  });

});
